//#region types
import { RectangularNodeProps } from "models/propTypes/chartProps";
import { IconDefinition } from "models/propTypes/iconPropTypes";
import { DisplayType } from "models/enums/style";
//#endregion
//#region components
import { Icon } from "components/common";
//#endregion
import cssExports from "theme/styles/main.module.scss";

export default function RectangularNode(props: RectangularNodeProps) {
  const { node } = props;

  const linesCount =
    (node.nodeDatum.name !== undefined && node.nodeDatum.name.length > 0 ? 1 : 0) +
    (node.nodeDatum.attributes?.description1 !== undefined &&
    ((typeof node.nodeDatum.attributes?.description1 === "string" &&
      node.nodeDatum.attributes?.description1.length > 0) ||
      typeof node.nodeDatum.attributes?.description1 !== "string")
      ? 1
      : 0) +
    (node.nodeDatum.attributes?.description2 !== undefined &&
    ((typeof node.nodeDatum.attributes?.description2 === "string" &&
      node.nodeDatum.attributes?.description2.length > 0) ||
      typeof node.nodeDatum.attributes?.description2 !== "string")
      ? 1
      : 0);

  const renderIcon = () => {
    const icon = node.nodeDatum?.icon as IconDefinition;
    if (icon === undefined) return undefined;

    icon.x = "-190";
    icon.y = "-15";

    return <Icon icon={icon} displayType={DisplayType.Info} />;
  };

  return (
    <g>
      <rect x="-200" y="-44" rx="12" ry="12" className={cssExports.rectSVGNode} />

      {renderIcon()}

      {node.nodeDatum.name && (
        <>
          <text x="-160" y={linesCount === 3 ? "-15" : linesCount === 2 ? "-5" : "5"} className={cssExports.nodeName}>
            {node.nodeDatum.name}
          </text>
          <br />
        </>
      )}

      {node.nodeDatum.attributes?.description1 && (
        <>
          <text x="-160" y={linesCount === 2 ? "15" : "5"} className={cssExports.nodeDescription}>
            {node.nodeDatum.attributes?.description1}
          </text>
          <br />
        </>
      )}

      {node.nodeDatum.attributes?.description2 && (
        <text
          x="-160"
          y={linesCount === 3 ? "25" : linesCount === 2 ? "15" : "5"}
          className={cssExports.nodeDescription}
        >
          {node.nodeDatum.attributes?.description2}
        </text>
      )}
    </g>
  );
}
